// scenario-resume.service.ts
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface ScenarioResumeData {
  sessionId: string;
  resumeToken: string;
  scenarioId: string;
  lastUpdated: string;
}

@Injectable({
  providedIn: 'root',
})
export class ScenarioResumeService {
  private readonly storageKeyPrefix = 'yo-scenario-resume:';

  constructor(private http: HttpClient) {}

  saveResumeData(data: ScenarioResumeData): void {
    const key = this.getStorageKey(data.scenarioId);

    localStorage.setItem(
      key,
      JSON.stringify({
        ...data,
        lastUpdated: new Date().toISOString(),
      }),
    );
  }

  getResumeData(scenarioId: string): ScenarioResumeData | null {
    const key = this.getStorageKey(scenarioId);
    const raw = localStorage.getItem(key);

    if (!raw) {
      return null;
    }

    try {
      return JSON.parse(raw) as ScenarioResumeData;
    } catch {
      localStorage.removeItem(key);
      return null;
    }
  }

  hasResumeData(scenarioId: string): boolean {
    return this.getResumeData(scenarioId) !== null;
  }

  clearResumeData(scenarioId: string): void {
    localStorage.removeItem(this.getStorageKey(scenarioId));
  }

  private getStorageKey(scenarioId: string): string {
    return `${this.storageKeyPrefix}${scenarioId}`;
  }

  fetchSession(id: string) {
    return this.http
      .get<any>(environment.apiUrl + '/resume_scenario_session/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          // do it here?
          //console.log(responseData);
          return responseData;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        }),
      );
  }
}
